export function toFormErrorPayload(error, fallbackMessage) {
  const isFieldValidationError = error?.status === 400
    && error?.exceptionType === 'RequestValidation'
    && Array.isArray(error?.fields);
  const fields = isFieldValidationError ? error.fields : [];
  const message = error?.message || fallbackMessage;
  return { message, fields };
}
